import FooterInfo from '../components/FooterInfo/FooterInfo'
import FooterNav from '../components/FooterNav/FooterNav'
import FooterSubscribe from '../components/FooterSubscribe/FooterSubscribe'
import FooterUser from '../components/FooterUser/FooterUser'

export { FooterInfo, FooterNav, FooterSubscribe, FooterUser }
